import { Lightning as lng } from '@lightningjs/sdk';
import { filterActionMap } from './FilterState';
import { ListFilterButton } from './ListFilterButton';
import { ActionButton } from '../../detail/actionRowButtons/ActionButton';
import { ListTranslationKeys } from '../../../api/models/TranslationKeys';

export class ListFilters extends lng.Component {
  static _template() {
    return {
      y: 0,
      w: w => w,
      List: {
        x: 0,
        y: 0,
        w: w => w,
        flex: { direction: 'row' },
      },
    };
  }

  _init() {
    this.focusIdx = 0;
    if (this.contentOffset) this.tag('List').x = this.contentOffset;
    this.reset();
  }

  reset() {
    this.tag('List').childList.clear();
    this.h = this.data.height();
    this.filterState.types.forEach((type, idx) => {
      this.tag('List').childList.a({
        flexItem: { marginLeft: 32 * (idx > 0 ? 1 : 0) },
        type: ListFilterButton,
        backend: this.backend,
        filterType: type,
        filterState: this.filterState,
        focusPast: this.data.focusPast,
        pastAndFuture: this.data.pastAndFuture,
        actionHandlerType: filterActionMap[type],
      });
    });

    let resetButton = this.tag('List').childList.a({
      flexItem: { marginLeft: 32 },
      type: ActionButton,
      backend: this.backend,
      visible: false,
      label: this.backend.translations.forKey(ListTranslationKeys.lists_btn_clearfilters_tv),
      actionHandler: {
        doAction: () => {
          this.filterState.reset();
        },
      },
    });

    const nrButtons = this.tag('List').childList.length;

    this.resetVisibleSetter = () => {
      const showReset = this.filterState.filtersSet();
      resetButton.visible = showReset;
      if (!showReset && this.focusIdx === nrButtons - 1) {
        this.focusIdx--;
      }
    };

    this.filterState.subscribe(this.resetVisibleSetter);
  }

  _getFocused() {
    return this._getFocusable()[this.focusIdx];
  }

  _handleRight() {
    let prevValue = this.focusIdx;
    this.focusIdx = Math.min(this.focusIdx + 1, this._getFocusable().length - 1);
    return prevValue !== this.focusIdx;
  }

  _handleLeft() {
    let prevValue = this.focusIdx;
    this.focusIdx = Math.max(this.focusIdx - 1, 0);
    return prevValue !== this.focusIdx;
  }

  _getFocusable() {
    return this.tag('List').children.filter(child => child.visible);
  }

  _detach() {
    this.filterState.subscriptions = undefined;
  }
}
